// The gatherings this device has opened (M71, D286), by message id: the
// title, and when it starts. The "Come now" ring names the gathering and
// knows when it's over, but the chat's messages in memory only hold the
// ones that arrived live: a gathering opened from a page of history lives
// in that chat's own state. Every sealed message is opened in one place
// (e2ee/session.ts `apply`), which records it here. Kept in memory for the
// visit only, never stored.

const MAX = 500;
const seen = new Map<string, { title: string; startsAt?: string }>();

export function rememberGatheringTitle(
  messageId: string,
  title: string,
  startsAt?: string
) {
  seen.delete(messageId);
  seen.set(messageId, { title, startsAt });
  // Oldest first out: a long visit doesn't grow without end.
  if (seen.size > MAX) seen.delete(seen.keys().next().value!);
}

export function gatheringTitleOf(messageId: string): string | undefined {
  return seen.get(messageId)?.title;
}

export function gatheringStartOf(messageId: string): string | undefined {
  return seen.get(messageId)?.startsAt;
}

/** For tests. */
export function forgetGatheringTitles() {
  seen.clear();
}
